import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	Grid, Col, Badge, Button,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { isEqual, filter } from 'lodash';
import {
	CardList, Loader, Image, Pagination,
} from '@components/common';
import utils from '@utils';
import { thunks } from '@redux/coordinators';
import { PageTitle } from '@components';
import CoordinatorCard from './components/coordinatorCard';

class CoordinatorsList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pendingInvitationsData : this.formatPendingInvitationsData(props.pendingInvitation || []),
		};
	}

	componentDidMount = () => {
		const { dispatch } = this.props;
		dispatch(thunks.getCoordinatorsData());
	}

	UNSAFE_componentWillReceiveProps = ({
		location : { search },
		history : { action },
		dispatch,
		pendingInvitation,
	}) => {
		const lastProps = this.props;
		if (search !== lastProps.location.search && action === 'POP') dispatch(thunks.handleQueryStringOnBackButtonClick(search));
		if (!isEqual(lastProps.pendingInvitation, pendingInvitation)) {
			this.setState({ pendingInvitationsData : this.formatPendingInvitationsData(pendingInvitation) });
		}
	}

	shouldComponentUpdate = ({
		data, loading, filters,
	}, { pendingInvitationsData }) => {
		const lastProps = this.props;
		const lastState = this.state;
		return (
			!isEqual(lastProps.data, data)
			|| !isEqual(lastProps.loading, loading)
			|| !isEqual(lastProps.filters, filters)
			|| !isEqual(lastState.pendingInvitationsData, pendingInvitationsData)
		);
	};

	formatPendingInvitationsData = (rawData) => filter(rawData, (item) => !item.Status);

	onPaginate = (pageNumber) => {
		const { dispatch } = this.props;
		dispatch(thunks.updateCoordinatorsFilter({ pageNumber }));
	}

	onClickCard = (Id) => {
		const { history } = this.props;

		history.push(`/coordinators/${Id}`);
	}

	pendingStatusChange = (item, status) => {
		const { dispatch } = this.props;
		dispatch(thunks.pendingStatusChange(item, status));
	}

	renderPendingInvitationList = (data) => {
		const { TimeZoneId } = this.props;
		return (
			<For
				each="item"
				of={data}
			>
				<div key={item.Id}>
					<div className="flex">
						<Image
							className="height-40 width-40 border-radius-20 margin-right-10 img-cover"
							src={item.InvitedByPhotoUrl || ''}
							fallbackSrc="avatar"
						/>
						<p className="margin-bottom-0 flex-1">
							<div className="flex">
								<span className="flex-2 font-regular display-block color-gray-oxford font-size-12">{ item.InvitedByUserFullName }</span>
								<span className="flex-1 font-light-italic color-gray-oxford pending-invitation-time-text">
									{ utils.parseUTCDateToTimeZone(item.CreateDateUTC, TimeZoneId).fromNow() }
								</span>
							</div>
							<span className="font-light display-block color-gray-oxford font-size-10">
								{ item.City }
								,
								{' '}
								{ item.State }
							</span>
						</p>
					</div>
					<div className="padding-top-10 padding-left-50">
						<Button
							bsStyle="primary"
							bsSize="xsmall"
							className="pending-invitations-button margin-right-5"
							onClick={() => this.pendingStatusChange(item, 1)}
						>
							Accept
						</Button>
						<Button
							bsStyle="danger"
							bsSize="xsmall"
							className="pending-invitations-button"
							onClick={() => this.pendingStatusChange(item, 2)}
						>
							Decline
						</Button>
					</div>
					<div className="separator" />
				</div>
			</For>
		);
	}

	render() {
		const { loading, filters : { pageNumber, totalCount, displayCount }, data } = this.props;
		const { pendingInvitationsData } = this.state;
		return (
			<Fragment>
				<PageTitle title="Coordinators & Agencies" />
				<Grid className="position-relative">
					<div className="coordinator-list-container">
						<Col
							md={9}
							sm={8}
							xs={12}
						>
							<CardList
								rowKey="Id"
								data={data}
								onClickCard={this.onClickCard}
								CardComponent={CoordinatorCard}
								mdValue={4}
								noDataHeader="Your coordinators are listed here."
								noDataMessage="You have not connected with any coordinator."
							/>
							<Pagination
								disabled={loading}
								totalCount={totalCount}
								displayCount={displayCount}
								pageNumber={pageNumber}
								onPaginate={this.onPaginate}
							/>
						</Col>
						<Col
							md={3}
							sm={4}
							xs={12}
						>
							<div className="bg-white padding-20 pending-invitations-container">
								<div>
									<span className="pending-invitation-text font-regular color-gray-cloud-burst">Pending Invitations</span>
									<Badge className="position-absolute right-35 top-25 bg-orange-1">{ pendingInvitationsData.length }</Badge>
								</div>
								<div className="separator" />
								<Choose>
									<When condition={!pendingInvitationsData.length}>
										<div className="flex-center flex-direction-column padding-top-50 padding-bottom-50">
											<img
												src="/images/no-data.png"
												alt="No data"
											/>
											<span className="font-light font-size-12 color-gray-oxford padding-top-10">No pending invitations</span>
										</div>
									</When>
									<Otherwise>
										{ this.renderPendingInvitationList(pendingInvitationsData) }
									</Otherwise>
								</Choose>
							</div>
						</Col>
					</div>
					<Loader active={loading} />
				</Grid>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	app : { user : { TimeZoneId } },
	coordinators : {
		data,
		loading : { list : loading },
		filters,
		pendingInvitation,
	},
}) => ({
	TimeZoneId,
	data,
	loading,
	filters,
	pendingInvitation,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
});

CoordinatorsList.propTypes = {
	TimeZoneId        : PropTypes.string,
	data              : PropTypes.array,
	dispatch          : PropTypes.func.isRequired,
	history           : PropTypes.object.isRequired,
	loading           : PropTypes.bool,
	pendingInvitation : PropTypes.array,
	filters           : PropTypes.object.isRequired,
	location          : PropTypes.object.isRequired,
};

CoordinatorsList.defaultProps = {
	TimeZoneId        : undefined,
	data              : [],
	loading           : false,
	pendingInvitation : [],
};

export default connect(mapStateToProps, mapDispatchToProps)(CoordinatorsList);
